// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  renderAssetId: __t.u64().primaryKey().name("render_asset_id"),
  contentHash: __t.string().name("content_hash"),
  kind: __t.string(),
  name: __t.string(),
  sourceUri: __t.string().name("source_uri"),
  polyCount: __t.u32().name("poly_count"),
  textureCount: __t.u16().name("texture_count"),
  materialCount: __t.u16().name("material_count"),
  sizeBytes: __t.u64().name("size_bytes"),
  vramEstimateMb: __t.u32().name("vram_estimate_mb"),
  hasLods: __t.bool().name("has_lods"),
  geometryCodec: __t.string().name("geometry_codec"),
  textureCodec: __t.string().name("texture_codec"),
  license: __t.string(),
  creator: __t.identity(),
  status: __t.string(),
  thumbnailUri: __t.string().name("thumbnail_uri"),
  createdAt: __t.timestamp().name("created_at"),
});
